import React, { Component } from 'react';
import { range } from 'lodash';
import { List, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import Img from '../../../../../../components/Img/Img';
import Slider from '../../../../../../components/utils/Slider/Slider';
import { TAG_RELATED_ITEM_TYPE } from '../../../../../../constants/service/app/tagConstants';
import {
  CS_REVIEW_DETAIL_URL_PATH,
  PRODUCT_EDIT_URL_PATH,
} from '../../../../../../constants/service/common/urlConstants';
import { DATE_FORMAT } from '../../../../../../constants/service/common/utilConstants';
import { openNewWindow, setDetailPageUrl, setNumberWithComma } from '../../../../../../lib/common';
import { setDateFormat } from '../../../../../../lib/moment';
import likeBtn from '../../../../../../static/images/common/like-btn.png';
import reviewBadge from '../../../../../../static/images/tag/tagDetailPreview/review-badge.png';
import reviewStarOff from '../../../../../../static/images/tag/tagDetailPreview/review-star-off.png';
import reviewStarOn from '../../../../../../static/images/tag/tagDetailPreview/review-star-on.png';
import './TagPreviewDetailPageFeed.scss';

class TagPreviewDetailPageFeed extends Component {
  constructor(props) {
    super(props);

    this.cache = new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 700,
    });
  }

  render() {
    const { itemList } = this.props;

    return (
      <div className="tag-preview-main-detail-page-feed">
        <List
          width={375}
          height={453}
          rowCount={itemList.length}
          rowHeight={this.cache.rowHeight}
          deferredMeasurementCache={this.cache}
          overscanRowCount={5}
          rowRenderer={({ key, index, parent, style }) => (
            <CellMeasurer key={key} cache={this.cache} parent={parent} columnIndex={0} rowIndex={index}>
              <div style={style}>
                {itemList[index].tagRelatedItemType === TAG_RELATED_ITEM_TYPE.PRODUCT ? (
                  <div className="tag-detail-product-item">
                    <Slider
                      className="tag-item-img-slider"
                      list={itemList[index].urlList}
                      arrows={false}
                      item={(url) => <Img clickAble={false} src={url} />}
                    />

                    <div className="tag-detail-item-contents">
                      <div className="product-title-and-like-btn-area">
                        <div
                          className="brand-name-and-product-name"
                          onClick={() =>
                            /**
                             *  태그의 연관된 타입에 따라서
                             *  상품일 경우 상품 상세 페이지,
                             *  상품 후기일 경우에는 상품 후기 상세 페이지를
                             *  새로운 브라우저창으로 열도록 함.
                             */
                            openNewWindow(
                              setDetailPageUrl(
                                itemList[index].tagRelatedItemType === TAG_RELATED_ITEM_TYPE.PRODUCT
                                  ? PRODUCT_EDIT_URL_PATH
                                  : CS_REVIEW_DETAIL_URL_PATH,
                                itemList[index].id,
                              ),
                            )
                          }
                        >
                          <div className="band-name">{itemList[index].storeName}</div>
                          <div className="bar" />
                          <div className="product-name">{itemList[index].productName}</div>
                        </div>

                        <Img className="like-btn" clickAble={false} src={likeBtn} />
                      </div>

                      <div className="product-info-tag-list">
                        <div className="product-info-tag">
                          <div className="label">색상</div>
                          <div className="contents">{itemList[index].tagColorList.join(',')}</div>
                        </div>
                        <div className="product-info-tag">
                          <div className="label">소재</div>
                          <div className="contents">{itemList[index].tagMaterialList.join(',')}</div>
                        </div>
                        {itemList[index].tagPostEarringList && itemList[index].tagPostEarringList.length ? (
                          <div className="product-info-tag">
                            <div className="label">침소재</div>
                            <div className="contents">{itemList[index].tagPostEarringList.join(',')}</div>
                          </div>
                        ) : null}
                      </div>

                      <div className="tag-list">
                        {itemList[index].tagList.map((tag, index) => (
                          <div className="tag" key={index}>
                            #{tag}
                          </div>
                        ))}
                      </div>

                      {itemList[index].likeCnt ? (
                        <div className="like-count">좋아요 {setNumberWithComma(itemList[index].likeCnt)}</div>
                      ) : null}
                    </div>
                  </div>
                ) : (
                  <div className="tag-detail-review-item">
                    <Slider
                      className="tag-item-img-slider"
                      list={itemList[index].urlList}
                      arrows={false}
                      item={(url) => <Img clickAble={false} src={url} />}
                    />

                    <Img className="review-badge" clickAble={false} src={reviewBadge} />

                    <div className="tag-detail-item-contents">
                      <div className="review-title-and-like-btn-area">
                        <div
                          className="review-start-and-user-info"
                          onClick={() =>
                            /**
                             *  태그의 연관된 타입에 따라서
                             *  상품일 경우 상품 상세 페이지,
                             *  상품 후기일 경우에는 상품 후기 상세 페이지를
                             *  새로운 브라우저창으로 열도록 함.
                             */
                            openNewWindow(
                              setDetailPageUrl(
                                itemList[index].tagRelatedItemType === TAG_RELATED_ITEM_TYPE.PRODUCT
                                  ? PRODUCT_EDIT_URL_PATH
                                  : CS_REVIEW_DETAIL_URL_PATH,
                                itemList[index].id,
                              ),
                            )
                          }
                        >
                          <div className="review-star">
                            {range(itemList[index].rate).map((star) => (
                              <Img className="star" key={star} clickAble={false} src={reviewStarOn} />
                            ))}
                            {range(5 - itemList[index].rate).map((star) => (
                              <Img className="star" key={star} clickAble={false} src={reviewStarOff} />
                            ))}
                          </div>
                          <div className="user-account">
                            {itemList[index].userAccount ? itemList[index].userAccount.slice(0, 4) + '**' : '-'}
                          </div>
                          <div className="bar" />
                          <div className="review-create-date">
                            {setDateFormat(itemList[index].createDate, DATE_FORMAT.YMD_DOT_FORMAT)}
                          </div>
                        </div>

                        <Img className="like-btn" clickAble={false} src={likeBtn} />
                      </div>

                      <div className="product-name">{itemList[index].productName}</div>

                      {itemList[index].productOptionName ? (
                        <div className="product-option">{itemList[index].productOptionName}</div>
                      ) : null}

                      <div className="review-content">{itemList[index].content}</div>

                      <div className="tag-list">
                        {itemList[index].reviewTagList &&
                          itemList[index].reviewTagList.map((tag, index) => (
                            <div className="tag" key={index}>
                              #{tag}
                            </div>
                          ))}
                      </div>

                      {itemList[index].likeCnt ? (
                        <div className="like-count">좋아요 {setNumberWithComma(itemList[index].likeCnt)}</div>
                      ) : null}
                    </div>
                  </div>
                )}
              </div>
            </CellMeasurer>
          )}
        />
      </div>
    );
  }
}

export default TagPreviewDetailPageFeed;
